export const ConstantsList = {
  ICP: 'ICP',
  SNS1: 'DKP',
  CHAT: 'CHAT',
  CKBTC: 'ckBTC',
}
